<template>
    <div>
        <template v-if="cantDisplayOnMobile">
            <div test-id="cannot-access-mobile-view" class="text-center">
                <div>
                    <img v-if="logo" class="w-auto h-20 mx-auto mt-10" :src="logo" alt="">
                </div>
                <div class="px-10 mt-10">
                    <div class="p-6 bg-white border border-gray-200 my-rounded">
                        <h1 class="text-2xl font-extrabold">Information</h1>
                        <p class="mt-1 text-sm font-light">Ce site est accessible uniquement sur grand écran</p>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            logo: {
                type: String
            }
        },
        data() {
            return {
                screenWidth: 0,
            }
        },

        computed: {
            cantDisplayOnMobile() {
                if (this.screenWidth <= 600 && (this.$companyTool.confFile() && !this.$companyTool.confFile().mobile)) {
                    return true
                }
                return false
            }
        },

        mounted() {
            this.screenWidth = window.innerWidth
            window.addEventListener('resize', (event) => {
                this.screenWidth = window.innerWidth
            }, true);
        }
    }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/SavResponsiveAccessTemplate.vue